import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=1d265e84&"
import script from "./ImageBlock.vue?vue&type=script&lang=ts&"
export * from "./ImageBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports